import React from 'react';
import CMSCustomSections from '../components/CMSCustomSections';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { useCMS } from '../hooks/useCMS';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  const navigate = useNavigate();
  const { content } = useCMS('services.overview');

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="bg-black text-white py-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6">{content('hero.title', 'Driven Experiences. Curated Fleet. Professional Execution.')}</h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {content('hero.subtitle', 'Three distinct service divisions designed for lifestyle mobility, elevated presence, and seamless coordination.')}
          </p>
        </div>
      </div>

      {/* Service Divisions */}
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Concierge */}
          <Card 
            className="p-8 hover:shadow-2xl transition-all cursor-pointer group border-t-4 border-t-red-600"
            onClick={() => navigate('/services/concierge')}
          >
            <h3 className="text-3xl font-bold text-black mb-4 group-hover:text-red-600 transition-colors">Concierge Driven</h3>
            <p className="text-gray-600 mb-8">
              Premium chauffeured transportation for weddings, corporate events, airport transfers, and VIP travel.
            </p>
            <div className="flex items-center text-red-600 font-semibold">
              Explore Services <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </div>
          </Card>

          {/* Exotic */}
          <Card 
            className="p-8 hover:shadow-2xl transition-all cursor-pointer group border-t-4 border-t-black"
            onClick={() => navigate('/services/exotic')}
          >
            <h3 className="text-3xl font-bold text-black mb-4 group-hover:text-red-600 transition-colors">Exotic Rentals</h3>
            <p className="text-gray-600 mb-8">
              Self-drive experiences in the world's finest machinery. Lamborghini, Ferrari, Rolls-Royce, and more.
            </p>
            <div className="flex items-center text-black font-semibold group-hover:text-red-600 transition-colors">
              View Fleet <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </div>
          </Card>

          {/* Group */}
          <Card 
            className="p-8 hover:shadow-2xl transition-all cursor-pointer group border-t-4 border-t-gray-400"
            onClick={() => navigate('/services/group')}
          >
            <h3 className="text-3xl font-bold text-black mb-4 group-hover:text-red-600 transition-colors">Group Transport</h3>
            <p className="text-gray-600 mb-8">
              Luxury Sprinters, mini-coaches, and party buses for large parties, corporate shuttles, and events.
            </p>
            <div className="flex items-center text-gray-700 font-semibold group-hover:text-red-600 transition-colors">
              Group Options <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </div>
          </Card>
        </div>
      </div>
      <CMSCustomSections pageId="services.overview" dark />
    </div>
  );
};

export default Services;
